import { vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0afd0e20")

_pushScopeId("data-v-0afd0e20")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "slider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["toggle-switch-button", {'disabled': _ctx.disabled, 'active': _ctx.localValue}],
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleValue()))
  }, [
    _withDirectives(_createVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue = $event))
    }, null, 512), [
      [_vModelCheckbox, _ctx.localValue]
    ]),
    _hoisted_1
  ], 2))
})